import React, { useEffect, useState } from "react";
import { TextField, MultiValue } from "cayo.ui";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { communicationChannelsWizardMessages } from "../../shared/messages";
import { validateEmails } from "../../shared/helpers";

type ConfigureProps = {
  sender: string;
  recipients: string[];
  handleChange: (key: string, value: string | string[]) => void;
};

export const Configure = ({ sender, recipients, handleChange }: ConfigureProps) => {
  const intl = useIntl();
  const [error, setError] = useState<{ index: number; errorMessage: string } | undefined>(
    undefined
  );

  useEffect(() => {
    const result = validateEmails(recipients);
    setError(result || undefined);
  }, [recipients]);

  return (
    <div>
      <TextField
        label={intl.formatMessage(communicationChannelsWizardMessages.configureExchangeOnlineField)}
        required
        value={sender}
        setValue={(value: string) => handleChange("sender", value)}
      />
      <RecipientsWrap>
        <MultiValue
          type="text"
          value={recipients}
          error={error}
          label={intl.formatMessage(
            communicationChannelsWizardMessages.configureExchangeOnlineRecipients
          )}
          allowItemCopy={false}
          setValue={(value) => {
            handleChange(
              "recipients",
              value?.map((v) => v?.value).filter((m) => m?.length) as string[]
            );
          }}
        />
      </RecipientsWrap>
    </div>
  );
};

const RecipientsWrap = styled.div`
  margin-top: 10px;
`;
